const r = {
  mouse: 0,
  drag: 0,
  touch: 100
};
class c {
  constructor(e = [], t = {}) {
    this.containers = [...e], this.options = {
      ...t
    }, this.dragging = !1, this.currentContainer = null, this.originalSource = null, this.startEvent = null, this.delay = a(t.delay);
  }
  attach() {
    return this;
  }
  detach() {
    return this;
  }
  addContainer(...e) {
    this.containers = [...this.containers, ...e];
  }
  removeContainer(...e) {
    this.containers = this.containers.filter((t) => !e.includes(t));
  }
  trigger(e, t) {
    const i = document.createEvent("Event");
    return i.detail = t, i.initEvent(t.type, !0, !0), e.dispatchEvent(i), this.lastEvent = t, t;
  }
}
function a(n) {
  const e = {};
  if (n === void 0)
    return {
      ...r
    };
  if (typeof n == "number") {
    for (const t in r)
      Object.prototype.hasOwnProperty.call(r, t) && (e[t] = n);
    return e;
  }
  for (const t in r)
    Object.prototype.hasOwnProperty.call(r, t) && (n[t] === void 0 ? e[t] = r[t] : e[t] = n[t]);
  return e;
}
export {
  c as default
};
